module.exports = __webpack_public_path__ + "static/media/codeCity.91a8ef8e.gif";